module.exports = __webpack_public_path__ + "static/media/vertical_Institute.9852fc6a.png";